var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 25,
    viewBox: "0 0 41 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .02h40.995V25H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.861 16.749c-1.285 1.017-2.88 2.12-4.682 3.037A10.738 10.738 0 0 0 31 12.51c0-2.81-1.073-5.368-2.822-7.276 1.803.916 3.397 2.02 4.682 3.037a36.877 36.877 0 0 1 4.497 4.239 36.868 36.868 0 0 1-4.497 4.239m-24.727 0a36.874 36.874 0 0 1-4.497-4.24c1.498-1.673 4.876-5.096 9.193-7.29a10.738 10.738 0 0 0-2.836 7.29c0 2.81 1.073 5.368 2.822 7.277-1.803-.917-3.397-2.02-4.682-3.037m12.363 3.5c-4.196 0-7.61-3.472-7.61-7.74 0-4.267 3.414-7.738 7.61-7.738 4.197 0 7.611 3.471 7.611 7.739 0 4.267-3.414 7.739-7.61 7.739m20.159-8.728c-.091-.117-2.276-2.906-5.808-5.715-2.09-1.662-4.226-2.99-6.348-3.947-2.706-1.22-5.399-1.84-8.004-1.84-2.605 0-5.297.62-8.004 1.84-2.12.957-4.256 2.285-6.347 3.947C2.614 8.616.43 11.404.338 11.521c-.45.58-.45 1.398 0 1.977.091.117 2.276 2.906 5.808 5.715 2.09 1.663 4.226 2.99 6.347 3.947 2.707 1.221 5.4 1.84 8.004 1.84 2.605 0 5.298-.619 8.004-1.84 2.122-.956 4.257-2.284 6.348-3.947 3.532-2.81 5.717-5.598 5.808-5.715.45-.58.45-1.397 0-1.977",
    fill: "#000",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ed112e3a00ab52a8aaf94f30ae6adf3a.svg";
export { ForwardRef as ReactComponent };